import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-veiw-mem-bill',
  templateUrl: './veiw-mem-bill.component.html',
  styleUrls: ['./veiw-mem-bill.component.css']
})
export class VeiwMemBillComponent implements OnInit {
  model: any;
  customer_id: any;
  complementry: any;
  showLoader: boolean = false;
  module_access: any;
  modChange: boolean = false;
  billDateChange: boolean = false;
  currentUser: any;
  todayDate: string = '';
  gstEnabled: boolean = false;
  cgst: number = 0;
  sgst: number = 0;
  constructor(
    private router: Router,
    private activerouter: ActivatedRoute,
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService
  ) {
    const today = new Date();
    this.todayDate = today.toISOString().split('T')[0]; // yyyy-MM-dd
  }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.gstEnabled = this.currentUser['gstEnabled'];
    if (this.gstEnabled == true) {
      // this.cgst = 0;
      // this.sgst = 0;
      this.cgst = this.currentUser['cgst'];
      this.sgst = this.currentUser['sgst'];
    } else {
      this.cgst = 0;
      this.sgst = 0;
    }
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    this.modChange = this.checkModuleAcces('34');
    this.billDateChange = this.checkModuleAcces('33');

    this.activerouter.queryParams.subscribe(params => {
      this.model = JSON.parse(params['model']);
      this.customer_id = params['customer_id']
    });

    this.model.memStartDate1 = this.loginservice.Objecttodate(this.model.memStartDate)
    this.model.memEndDate1 = this.loginservice.Objecttodate(this.model.memEndDate)

    this.model.totPerson = 1;

    if (this.model.person1phone > 0) {
      this.model.totPerson += 1;
    }

    if (this.model.person2phone > 0) {
      this.model.totPerson += 1;
    }

    if (this.customer_id) {
      this.loginservice.getMemDetail(this.customer_id, this.currentUser)
        .subscribe(
          data => {
            this.model['service_category'] = data['data']['service_category'];
            this.model['memAmt'] = data['data']['memAmt'];
            this.model['compMonth'] = data['data']['compMonth'];
            this.complementry = data['data1'];

            this.model['packId'] = data['data3']['id'];
            this.model['mem_id'] = data['data3']['mem_id'];
            this.model['paidAmount'] = data['data3']['paidAmount'];
            this.model['purchased_date'] = data['data3']['date'];
            this.model['paidAmount'] = data['data3']['paidAmount'];
            this.model['cash'] = data['data3']['cash'];
            this.model['g_pay'] = data['data3']['g_pay'];
            this.model['card'] = data['data3']['card'];
            this.model['cheque'] = data['data3']['cheque'];
            this.model['due'] = data['data3']['due'];
            this.model['online_banking'] = data['data3']['online_banking'];
            this.model['salary'] = data['data3']['salary'];
          }, error => { alert('Network Error getMemDetail API'); });
    }
  }


  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      return true; // module exists
    } else {
      // If not found, reset and return false
      return false;
    }
  }

  convertToWords(number: number): string {
    // Define an array of words for numbers 0 to 19
    const units: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    // Define an array of words for tens multiples
    const tensMultiples: string[] = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    // Define an array of words for powers of thousand
    const tensPowers: string[] = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    // Function to convert numbers less than 1000 to words
    const convertLessThanOneThousand = (num: number): string => {
      if (num === 0) {
        return '';
      }

      let word = '';

      if (num < 20) {
        word = units[num];
      } else if (num < 100) {
        word = tensMultiples[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
      } else {
        word = units[Math.floor(num / 100)] + ' Hundred ' + convertLessThanOneThousand(num % 100);
      }

      return word.trim();
    };

    // Function to convert large numbers to words
    const convertToWordsHelper = (num: number, power: number): string => {
      if (num === 0) {
        return '';
      }

      const higherPart = Math.floor(num / 1000);
      let word = '';

      // Call recursively if there's a higher part (greater than 1000)
      if (higherPart > 0) {
        word = convertToWordsHelper(higherPart, power + 1);
      }

      const remainder = convertLessThanOneThousand(num % 1000);

      if (remainder) {
        word += (word ? ' ' : '') + remainder + ' ' + tensPowers[power];
      }

      return word.trim();
    };

    // Handle the decimal part (if applicable)
    const handleDecimalPart = (num: number): string => {
      const decimalPart = Math.round((num % 1) * 100); // Get the fractional part as an integer (e.g., 79.2 => 20)
      if (decimalPart > 0) {
        if (decimalPart < 20) {
          return ' point ' + units[decimalPart] + ' paisa'; // Convert to words for numbers below 20
        } else {
          return ' point ' + tensMultiples[Math.floor(decimalPart / 10)] + ' ' + (decimalPart % 10 !== 0 ? units[decimalPart % 10] + ' paisa' : 'paisa');
        }
      }
      return '';
    };

    if (number === 0) {
      return 'Rupees Zero Only';
    }

    // Separate the integer part and decimal part
    const integerPart = Math.floor(number);
    const decimalPart = handleDecimalPart(number);

    // Convert the integer part to words and append the decimal part if it exists
    const words = convertToWordsHelper(integerPart, 0).trim();

    // Return the final output with "Rupees" and "paisa" formatting
    return 'Rupees ' + words + decimalPart;
  }

  public mprint() {
    window.print();
  }

  packdateChange() {
    if (this.model.purchased_date) {
      const selectedDate = new Date(this.model.purchased_date);
      const today = new Date(this.todayDate);
      // Reset if selected date is in the future
      if (selectedDate > today) {
        alert('Future dates are not allowed!');
        this.model.purchased_date = this.todayDate; // Reset to today's date or clear

        // Optional: Notify backend or log this action (if required)
        return;
      }
      // Proceed with valid date
      this.loginservice.packdateChange(this.model, this.currentUser).subscribe(
        (data) => {
        },
        (error) => {
          alert('Network Error packdateChange API');
          console.error('Error updating date:', error);
        }
      );
    }
  }

  savePackagepaymentMode() {
    let totPay = (Number(this.model.cash) || 0) + (Number(this.model.g_pay) || 0) + (Number(this.model.card) || 0) + (Number(this.model.cheque) || 0) + (Number(this.model.due) || 0) + (Number(this.model.online_banking) || 0) + (Number(this.model.salary) || 0);
    let allAmt = this.roundGst(Number(this.model.paidAmount) + ((Number(this.model.paidAmount) * Number(this.sgst)) / 100) + ((Number(this.model.paidAmount) * Number(this.cgst)) / 100))
    this.model.cgst = this.cgst;
    this.model.sgst = this.sgst;
    this.model.cgst_amt = (Number(this.model.paidAmount) * Number(this.cgst)) / 100;
    this.model.sgst_amt = (Number(this.model.paidAmount) * Number(this.sgst)) / 100;
    if (allAmt === Number(Number(totPay).toFixed(1))) {
      this.loginservice.savePackagepaymentMode(this.model, this.currentUser)
        .subscribe(
          data => {
            this._flashMessagesService.show('Payment Mode Saved!', { cssClass: 'alert-success' });
          }, error => { alert('Network Error savePackagepaymentMode API'); });
    } else {
      alert('Mis-match')
    }
  }
  roundGst(value) {
    return Math.round(value);
  }

  getBillLogoPath(): string {
    if (this.currentUser && this.currentUser.billLogo) {
      // If salon has custom bill logo, use upload URL
      return `${environment.uploadUrl}uploads/salon_bill_logos/${this.currentUser.billLogo}`;
    }
    // Default logo
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/app/veiw-mem-bill/veiw-mem-bill.component.ts